import { Flex, Spin } from "antd";
import "./loader.scss";

interface LoaderProps {
  fullscreen?: boolean;
  size?: "small" | "default" | "large";
}

const Loader = ({ fullscreen = false, size = "large" }: LoaderProps) => {
  return (
    <Flex
      justify="center"
      align="center"
      className={fullscreen ? "loader fullscreen" : "loader container"}
    >
      <Spin size={size} />
    </Flex>
  );
};

export default Loader;
